import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import './footer.scss';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  APP_URL,
  LEGIT_SCRIPT,
  SOURCESTOLAZYLOAD
} from '../../constants/defaults';
import loadable from '@loadable/component';
import NewFooter from '../NewFooter';
import { Helmet } from 'react-helmet';
import MenuAccordian from '../common/MenuAccordian';
import SignupNews from '../SignupNews';
import BrowseTopDrugsAlphabet from '../common/BrowseDrugsAlphabet';
import LazyImageWithNoscript from '../common/LazyImageWithNoscript';
const AuthenticatedModal = loadable(() =>
  import('../HomeDeliveryNew/AuthenticateModal')
);

const SiteFooter = ({ userName }) => {
  const [showSignupModal, setSignupModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();
  const history = useHistory();
  let isUserLogin = !_.isUndefined(userName) && !_.isEmpty(userName);
  let lang = i18n.language;

  const changeLanguage = lng => {
    let newUrl = _.withLocale(lng, history.location.pathname);
    return newUrl;
  };

  useEffect(() => {
    loadHtmlCode();
    const utmzCookie = _.getCookie('_utmz_custom');
    const urlParams = new URLSearchParams(window.location.search);
    // Execute if the cookie doesn't exists or the necessary params are provided

    const gclidURL = urlParams.get('gclid');
    if (
      _.isEmpty(utmzCookie) ||
      history.location.hash === '#fw' ||
      (!_.isEmpty(urlParams.get('utm_source')) &&
        !_.isEmpty(urlParams.get('utm_medium'))) ||
      !_.isEmpty(gclidURL)
    ) {
      _.utmTrack();
    }
  }, []);

  const toggleSignupModal = () => {
    setSignupModal(!showSignupModal);
  };

  const htmlDecode = html => {
    return html.replace(/&([a-z]+);/gi, (match, entity) => {
      const entities = {
        amp: '&',
        apos: "'",
        gt: '>',
        lt: '<',
        nbsp: '\xa0',
        quot: '"'
      };
      entity = entity.toLowerCase();
      if (Object.prototype.hasOwnProperty.call(entities, entity)) {
        return entities[entity];
      }
      return match;
    });
  };

  const loadHtmlCode = () => {
    if (typeof document !== 'undefined') {
      let legitDiv = document.getElementById('legit');
      if (legitDiv) {
        if (document.getElementById('sslScript'))
          document.getElementById('sslScript').appendChild(legitDiv);
        if (document.getElementById('sslScriptMobile'))
          document.getElementById('sslScriptMobile').appendChild(legitDiv);
      }
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const applyLazyToThirdPartyImages = () => {
        const allImages = document.querySelectorAll('img');
        allImages.forEach(img => {
          const src = img.getAttribute('src') || '';
          if (
            !img.hasAttribute('loading') &&
            SOURCESTOLAZYLOAD.some(domain => src.includes(domain))
          ) {
            img.setAttribute('loading', 'lazy');
          }
        });
      };
      applyLazyToThirdPartyImages();
      // Watch for dynamically injected images
      const observer = new MutationObserver(() => {
        applyLazyToThirdPartyImages();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    }
  }, []);

  const renderSocialIconsForNoJs = () => {
    return (
      <div>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.trustpilot.com/review/www.singlecare.com"
            >
              <LazyImageWithNoscript
                src="/content/images/footer/Trustpilot.svg"
                alt={t('Trustpilot logo')}
                className="footerSocialicon"
              />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/singlecare"
            >
              <LazyImageWithNoscript
                src="/content/images/footer/LinkedIn.svg"
                alt={t('LinkedIn')}
                className="footerSocialicon"
              />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/SingleCare"
            >
              <LazyImageWithNoscript
                src="/content/images/footer/Facebook.svg"
                alt={t('Facebook')}
                className="footerSocialicon"
              />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/singlecare/?hl=en"
            >
              <LazyImageWithNoscript
                src="/content/images/footer/Instagram.svg"
                alt={t('Instagram')}
                className="footerSocialicon"
              />
            </a>
          </li>

          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.twitter.com/singlecare"
            >
              <LazyImageWithNoscript
                src="/content/images/footer/Twitter-footer.svg"
                alt={t('Twitter')}
                className="footerSocialicon"
              />
            </a>
          </li>
        </ul>
      </div>
    );
  };

  return _.isNewFooter(history.location.pathname) ? (
    <div>
      <NewFooter />
    </div>
  ) : (
    <div>
      <Helmet>
        <script type="text/javascript">
          {`function openBanner() {
                OneTrust.ToggleInfoDisplay();
              }`}
        </script>
      </Helmet>
      {_.isHeaderAndFooterVisible(history.location.pathname) && (
        <>
          {history.location.pathname !== '/forgot-password' &&
            history.location.pathname !== '/es/restablecer-contrasena' && (
              <BrowseTopDrugsAlphabet />
            )}
          {_.isEqual(lang, 'en') && <SignupNews />}
          <div
            className="homepage-footer"
            role="contentinfo"
            aria-label="Copyrights, support, partners, terms & conditions and links to social media"
          >
            {showSignupModal && (
              <div className="mainModal afterSignupmodal">
                <div
                  className="transparentBg"
                  onClick={toggleSignupModal}
                ></div>
                <div className="signUpModal">
                  <AuthenticatedModal
                    hideAuthenticateModal={toggleSignupModal}
                  />
                </div>
              </div>
            )}

            <div className="footerSectionWrapper">
              <section>
                <MenuAccordian
                  menuList={_.getAccordianMenu(t, lang, isUserLogin)}
                  isFromFooter={true}
                />
              </section>
              <section className="footerMiddleSection">
                <div className="social-icons">
                  <LazyLoadComponent>
                    {renderSocialIconsForNoJs()}
                  </LazyLoadComponent>
                  <noscript>{renderSocialIconsForNoJs()}</noscript>
                  <div className="appIconWrapper">
                    <div>
                      <ul>
                        <li className="site-footer-bbb ios-app">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={APP_URL.FOOTER_IOS_LINK}
                            aria-label="SingleCare iOS App"
                          >
                            {_.isEqual(lang, 'en') ? (
                              <div className="spanishHide">
                                <LazyImageWithNoscript
                                  src="/content/images/footer/appStore-footer.svg"
                                  alt={t('App Store footer')}
                                  className="footerSocialicon"
                                />
                              </div>
                            ) : (
                              <div className="spanishMapShow">
                                <LazyImageWithNoscript
                                  className="map-img"
                                  alt={t('App Store footer')}
                                  src="/content/images/homepagev2/app-store-badge-footer-spanish.svg"
                                />
                              </div>
                            )}
                          </a>
                        </li>
                        <li className="site-footer-bbb android-app">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={APP_URL.FOOTER_ANDROID_LINK}
                            aria-label="SingleCare Android App"
                          >
                            {_.isEqual(lang, 'en') ? (
                              <div className="spanishHide">
                                <LazyImageWithNoscript
                                  src="/content/images/footer/google-play-footer.svg"
                                  alt={t('Google play')}
                                  className="footerSocialicon"
                                />
                              </div>
                            ) : (
                              <div className="spanishMapShow">
                                <LazyImageWithNoscript
                                  className="map-img"
                                  alt={t('Google play badge spanish')}
                                  src="/content/images/homepagev2/google-play-badge-footer-spanish.svg"
                                />
                              </div>
                            )}
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="ratingImage">
                      <LazyImageWithNoscript
                        src="/content/images/apps/rating-yellow.svg"
                        className="ratingImg"
                        height="16px"
                        width="80px"
                        alt=""
                      />
                      <span className="desktop-only">
                        {t('4.8 average ratings')}
                      </span>
                      <span className="mobile-only">{t('4.8 rating')}</span>
                    </div>
                  </div>
                </div>
                <div className="footerParagraph">
                  <p>
                    <strong>
                      {t('Prescription savings vary by prescription')}
                    </strong>{' '}
                    {t('This is a medical discount plan')}
                  </p>
                  <p>{t('Medical disclaimer')}</p>
                </div>
                <div className="footerLogos">
                  <div className="legitScriptDiv">
                    <ul>
                      <li id="sslScript" className="sslScript">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: htmlDecode(LEGIT_SCRIPT)
                          }}
                        />
                      </li>
                      <li className="site-footer-nabp">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.safe.pharmacy/buying-safely/"
                          aria-label="Safe Pharmacy"
                        >
                          <LazyImageWithNoscript
                            src="/content/images/footer/safe-pharmacy-logo.jpg"
                            alt={t('safe-pharmacy')}
                            className="footerSocialicon"
                            height="40px"
                            width="149px"
                          />
                        </a>
                      </li>
                      <li className="site-footer-bbb">
                        <span tabIndex="-1">
                          <LazyImageWithNoscript
                            src="/content/images/footer/BBB-logo.jpg"
                            alt={t('BBB')}
                            className="footerSocialicon"
                            height="43px"
                            width="117px"
                          />
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-partners">
                    <ul>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          target="_blank"
                          href="https://www.mhanational.org/about"
                          aria-label="Mental Health America"
                        >
                          <LazyImageWithNoscript
                            src="/content/images/footer/logos-partner-mha.svg"
                            width="105px"
                            height="32px"
                            alt={t('Mental Health America logo')}
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          target="_blank"
                          href="https://www.heart.org/en/about-us"
                          aria-label="American Heart Association"
                        >
                          <LazyImageWithNoscript
                            src="/content/images/footer/logos-partner-heart.svg"
                            width="100px"
                            height="32px"
                            alt={t('logos-partner-heart')}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <section className="footerLastSection">
                <div className="footerLastLinks">
                  <ul>
                    {_.isHeaderForLandingPage(history.location.pathname) && (
                      <li>
                        <>
                          {i18n.language === 'en' ? (
                            <a
                              className="spanishBtn"
                              href={changeLanguage('es')}
                            >
                              Español
                            </a>
                          ) : (
                            <a
                              className="englishBtn"
                              href={changeLanguage('en')}
                            >
                              English
                            </a>
                          )}
                        </>
                      </li>
                    )}
                    <li>
                      <a
                        id="slmFootTerms"
                        href={_.withLocale(lang, '/terms-and-conditions')}
                      >
                        {t('Terms & Conditions footer')}
                      </a>
                    </li>
                    <li>
                      <a
                        id="slmFootPrivacyPolicy"
                        href={_.withLocale(lang, '/privacy-policy')}
                      >
                        {t('Footer Privacy Policy')}
                      </a>
                    </li>
                    <li>
                      <a
                        id="slmFootPrivacyPolicy"
                        onClick={() => {
                          window.openBanner();
                        }}
                        onKeyPress={() => {
                          window.openBanner();
                        }}
                        tabIndex={0}
                      >
                        {t('Your Privacy Choices')}
                      </a>
                    </li>
                    <li className="washintonPrivacyPolicyLabel">
                      <a
                        id="washintonPrivacyPolicy"
                        href={_.withLocale(
                          lang,
                          '/washington-consumer-health-privacy-policy'
                        )}
                      >
                        {t('WA Consumer Health Privacy Policy')}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="copyrightSection">
                  <div>
                    <p className="footer-copyright">
                      {`© ${new Date().getFullYear()}`}&nbsp;
                      <a href={_.withLocale(lang, '/')}>SingleCare</a>
                      &nbsp;Administrators.&nbsp;
                      {t('All rights reserved')}
                    </p>
                  </div>
                  <div>
                    <a href={_.withLocale(lang, '/')}>
                      <LazyImageWithNoscript
                        src="/content/images/header/single-care-logo1.svg"
                        width="148px"
                        height="24px"
                        alt="SingleCare"
                        className="singlecare-logo"
                      />
                    </a>
                  </div>
                </div>
                <div className="copyrightSection copyrightSectionMobile">
                  <div>
                    <a href={_.withLocale(lang, '/')}>
                      <LazyImageWithNoscript
                        src="/content/images/header/single-care-logo1.svg"
                        width="148px"
                        height="24px"
                        alt="SingleCare"
                        className="singlecare-logo"
                      />
                    </a>
                  </div>
                  <div>
                    <p className="footer-copyright">
                      {`© ${new Date().getFullYear()}`}&nbsp;
                      <a href={_.withLocale(lang, '/')}>SingleCare</a>
                      &nbsp;Administrators.&nbsp;
                      {t('All rights reserved')}
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default React.memo(SiteFooter);
